module.exports = __webpack_public_path__ + "img/H01122-J04.3286580c.jpg";